import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-top: 1rem;

  p {
    text-align: start;
  }
`;

export const FormInput = styled.input`
  padding: 0.4rem;
  margin-bottom: 0.4rem;
  width: 200px;
`;

export const FormButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;
